export const PATH_ERROR = "/error";
export const PATH_NOT_FOUND = "/:pathMatch(.*)*";
export const PATH_UNAUTHORIZED = "/unauthorized";
